"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TimeSpan_1 = require("../TimeSpan");
/**
 * Oblicza różnicę pomiędzy datami
 * @param lateDate data późniejsza
 * @param earlyDate data wcześniejsza
 */
function dateDiff(lateDate, earlyDate) {
    return TimeSpan_1.default.diff(lateDate, earlyDate);
}
exports.default = dateDiff;
//# sourceMappingURL=dateDiff.js.map